/**
 * Created by iamso on 16.07.20.
 */

const DiscoverButtonBooster = BaseButtonBooster.extend({
    ctor: function (booster) {
        const styles = cleverapps.styles.DiscoverButtonBooster;
        styles.mirrorArrowY = cleverapps.resolution.mode !== cleverapps.WideMode.SQUARE;

        this._super({
            booster,
            styles
        });
    },

    getLayoutOptions: function () {
        return {
            direction: this.styles.content.direction[cleverapps.resolution.mode],
            margin: this.styles.content.margin[cleverapps.resolution.mode]
        };
    },

    onResize: function () {
        this.icon.setScale2(this.styles.content.iconScale);

        this._super();
    },

    toggleArrow: function (on, ...args) {
        if (cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_REGULAR) {
            this._super.call(this, on, ...args);
        } else if (!on || this.booster.canExecute()) {
            this._super.call(this, on, ...args);
        }
    },

    toggleTint: function (on, ...args) {
        if (cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_REGULAR) {
            this._super.call(this, on, ...args);
        } else if (!on || this.booster.canExecute()) {
            this._super.call(this, on, ...args);
        }
    },

    createIcon: function () {
        const animation = new cleverapps.Spine(bundles.game.jsons.discovery_icon_json);
        animation.setAnimation(0, "idle", true);
        return animation;
    },

    getSize: function () {
        return this.styles.size[cleverapps.resolution.mode];
    },

    getFreeTextWidth: function () {
        const styles = this.styles.content.freeBlock[cleverapps.resolution.mode];

        return styles.textWidth;
    },

    _innerUpdateBgContent: function () {
        const bright = this.bright && !this.disabled;
        this._super();
        if (cleverapps.forces.isRunningForce(this.booster.force)) {
            return;
        }
        if (!bright) {
            [this.background, this.icon].forEach((item) => {
                cleverapps.UI.convertToGrayScale(item.spine || item);
            });
        }
    }

});

cleverapps.styles.DiscoverButtonBooster = {
    size: [{ width: 240, height: 100 }, { width: 180, height: 160 }, { width: 240, height: 100 }],
    zOrder: 0,

    type: cleverapps.styles.UI.Button.Images.button_blue,

    scale: [0.8, 1, 1],

    content: {
        freeBlock: [{ textWidth: 110 }, { textWidth: 120 }, { textWidth: 110 }],
        iconScale: [0.55, 0.7, 0.55],
        margin: [0, -12, 0],
        direction: [cleverapps.UI.HORIZONTAL, cleverapps.UI.VERTICAL, cleverapps.UI.HORIZONTAL],
        layout: [
            { x: { align: "center", dx: -5 }, y: { align: "center", dy: 0 } },
            { x: { align: "center", dx: 0 }, y: { align: "center", dy: 7 } },
            { x: { align: "center", dx: -5 }, y: { align: "center", dy: 0 } }
        ]
    }
};